jQuery(document).ready(function($){
    $('.owl-testimonial').owlCarousel({
        loop: true,
        autoplay: true,
        dots: false, 
        nav: true,
        margin: 40,
        responsive: {
            0: {
                items: 1,
            },
            1024: {
                items: 2,
            }
        }
    });

    $('.owl-logos').owlCarousel({
        loop: true,
        autoplay: true,
        dots: false, 
        nav: true,
        margin: 40,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            }
        }
    });

    $('.owl-blog').owlCarousel({
        loop: false,
        autoplay: false,
        dots: false, 
        nav: true,
        margin: 40,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            }
        }
    });

    $('.owl-product-single').owlCarousel({
        loop: true,
        autoplay: true,
        dots: false, 
        nav: true,
        margin: 20,
        stagePadding: 60,
        responsive: {
            0: {
                items: 1,
            },
        }
    });

    $("#um-submit-btn").text('Entrar')

    $("#wc-bookings-booking-form , .wc-bookings-booking-form-button").addClass("d-none");

    $("#reservaBtn").click(function() {
        $("#reservaBtn , .owl-product-single, .aviso").addClass("d-none");
        $("#wc-bookings-booking-form, .wc-bookings-booking-form-button").removeClass("d-none");
    });
});
